export const RESTAURANT_SEARCH_SYNONYMS: Record<string, string[]> = {
    // === MEAT & POULTRY ===
    salmon: ["zalm"],
    zalm: ["salmon"],
    chicken: ["kip", "kipfilet", "kippedij", "kippenvlees", "haantje"],
    kip: ["chicken"],
    beef: ["rund", "rundvlees", "biefstuk", "runder", "ossehaas"],
    rund: ["beef"],
    pork: ["varken", "varkensvlees", "spek", "procureur", "schouderkarbonade"],
    varken: ["pork"],
    lamb: ["lam", "lamsvlees", "lamskotelet"],
    lam: ["lamb"],
    turkey: ["kalkoen", "kalkoenfilet"],
    kalkoen: ["turkey"],
  
    // === FISH & SEAFOOD ===
    tuna: ["tonijn"],
    tonijn: ["tuna"],
    cod: ["kabeljauw"],
    kabeljauw: ["cod"],
    shrimp: ["garnaal", "garnalen", "scampi", "gamba"],
    garnaal: ["shrimp", "prawn"],
    mussel: ["mossel", "mosselen"],
    mossel: ["mussel"],
  
    // === DAIRY & EGGS ===
    cheese: ["kaas"],
    kaas: ["cheese"],
    milk: ["melk"],
    melk: ["milk"],
    butter: ["boter"],
    boter: ["butter"],
    cream: ["room", "slagroom", "kookroom"],
    room: ["cream"],
    egg: ["ei", "eieren"],
    ei: ["egg"],
  
    // === VEGETABLES & FRUITS ===
    potato: ["aardappel", "patat", "kriel", "frietaardappel"],
    aardappel: ["potato"],
    tomato: ["tomaat"],
    tomaat: ["tomato"],
    onion: ["ui", "ajuin", "rode ui"],
    ui: ["onion"],
    garlic: ["knoflook"],
    knoflook: ["garlic"],
    carrot: ["wortel", "peen", "bospeen"],
    wortel: ["carrot"],
    lettuce: ["sla", "kropsla", "ijsbergsla", "romeinse sla"],
    sla: ["lettuce"],
    cucumber: ["komkommer"],
    komkommer: ["cucumber"],
    pepper: ["paprika", "puntpaprika"],
    paprika: ["bell pepper", "pepper"],
  
    // === DRY GOODS ===
    rice: ["rijst"],
    rijst: ["rice"],
    pasta: ["macaroni", "spaghetti", "penne", "tagliatelle"],
    flour: ["bloem", "tarwebloem", "patentbloem"],
    bloem: ["flour"],
    sugar: ["suiker", "kristalsuiker", "basterdsuiker"],
    suiker: ["sugar"],
    oil: ["olie", "zonnebloemolie", "olijfolie", "frituurolie"],
    olie: ["oil"],
  
    // === DRINKS ===
    beer: ["bier", "pils", "heineken", "jupiler"],
    bier: ["beer"],
    wine: ["wijn", "rode wijn", "witte wijn"],
    wijn: ["wine"],
    cola: ["coca cola", "coca-cola", "pepsi"],
    water: ["spa blauw", "spa rood", "bruiswater", "mineraalwater"],
  
    // === CLEANING & HYGIENE ===
    "toilet paper": ["wc papier", "toiletpapier", "wc-papier"],
    "wc papier": ["toilet paper"],
    "trash bag": ["vuilniszak", "pedaalemmerzak", "afvalzak"],
    vuilniszak: ["trash bag", "garbage bag"],
    "cleaning spray": ["schoonmaakspray", "allesreiniger", "cif"],
    allesreiniger: ["all-purpose cleaner", "cleaning spray"],
    "dish soap": ["afwasmiddel", "dreft", "sunlight"],
    afwasmiddel: ["dish soap"],
    glove: ["handschoen", "nitril handschoen", "latex handschoen", "vinyl"],
    handschoen: ["glove", "gloves"],
    napkin: ["servet", "papieren servet", "tafelsservet"],
    servet: ["napkin", "paper napkin"],
  
    // === PACKAGING & DISPOSABLES ===
    "takeaway box": ["menubox", "magnetronbak", "cpeth", "maaltijdbak"],
    menubox: ["takeaway box", "food container"],
    "aluminum foil": ["aluminiumfolie", "alufolie"],
    aluminiumfolie: ["aluminum foil", "aluminium foil"],
    "cling film": ["vershoudfolie", "huishoudfolie", "plastic folie"],
    vershoudfolie: ["cling film", "plastic wrap", "saran wrap"],
    "coffee cup": ["koffiebeker", "koffie beker", "to go beker"],
    koffiebeker: ["coffee cup", "takeaway cup"],
    straw: ["rietje", "papieren rietje"],
    rietje: ["straw"],
  };